import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import EventSaveInfo from '../EventSaveInfo';
import EventSaveNavbar from '../EventSaveNavbar';
import Tabs from '../../../../components/Tabs';
import EventSectionList from '../EventSectionList';
import SelectProductListForm from '../components/SelectProductListForm';
import SelectTagListForm from '../components/SelectTagListForm';
import EventColorSet from '../EventColorSet';
import EventFilterExpose from '../EventFilterExpose';
import { EventDetailResponse } from '../../../../types/query/event/detail';
import { SectionTab } from '../types';
import { NUMBER_OF_EVENT_ITEM_COUNT } from '../../../../constants/service/app/eventConstants';
import './EventSaveWrap.scss';

interface EventSaveWrapProps extends FormComponentProps {
  eventSave: EventDetailResponse;
  onSubmit: () => void;
  preview: () => void;
  eventSaveInfoTabKey: number;
  setEventSaveInfoTabKey: React.Dispatch<React.SetStateAction<number>>;
  eventSectionTabKey: number | null;
  setEventSectionTabKey: React.Dispatch<React.SetStateAction<number | null>>;
}
const EventSaveWrap = (props: EventSaveWrapProps) => {
  const {
    form,
    eventSave,
    onSubmit,
    preview,
    eventSaveInfoTabKey,
    setEventSaveInfoTabKey,
    eventSectionTabKey,
    setEventSectionTabKey,
  } = props;
  const {
    eventSectionList,
    eventProductList,
    eventTagList,
    eventColorSet,
    itemDefaultSortType,
    isItemFilterExpose,
    ...eventInfo
  } = eventSave;
  const hasSectionWithMobility = !!form
    .getFieldValue('sectionTabList')
    ?.find((item: SectionTab) => item.isSectionMobility);

  return (
    <div className="event-save-wrap">
      {/* 하단 네브바 */}
      <EventSaveNavbar onSubmit={onSubmit} preview={preview} />

      {/*기획전 등록/편집*/}
      <Tabs
        activeKey={eventSaveInfoTabKey}
        onChange={(tabKey: number) => setEventSaveInfoTabKey(tabKey)}
        list={[
          {
            title: '기획전 정보',
            content: (
              <div className="event-info">
                <EventSaveInfo form={form} {...eventInfo} />

                <EventSectionList
                  form={form}
                  list={eventSectionList}
                  eventSectionTabKey={eventSectionTabKey}
                  setEventSectionTabKey={setEventSectionTabKey}
                />

                {hasSectionWithMobility ? (
                  <>
                    <hr />
                    <EventColorSet form={form} colorSet={eventColorSet} />
                  </>
                ) : null}
              </div>
            ),
            forceRender: true,
          },
          {
            title: '기획전 아이템 정보',
            content: (
              <div>
                <EventFilterExpose name={'isItemFilterExpose'} form={form} initialValue={isItemFilterExpose} />
                <SelectProductListForm
                  form={form}
                  name={'event-product-items'}
                  initialValue={eventProductList}
                  max={NUMBER_OF_EVENT_ITEM_COUNT}
                />
              </div>
            ),
            forceRender: true,
          },
          {
            title: '기획전 태그 정보',
            content: <SelectTagListForm form={form} name={'event-tag-items'} initialValue={eventTagList} />,
            forceRender: true,
          },
        ]}
      />
    </div>
  );
};

export default EventSaveWrap;
